module.exports = __webpack_public_path__ + "static/media/gift-3.6ac882f8.png";